import { c as click, s as showAccountManageWarning, d as destroyLocalTracking, g as getAttr, a as addClass, b as setDataAttr, q as qs, e as getStoredUTMParams, t as trackSignupStarted, r as runAll, f as removeClass, o as onReady } from './app-chunk-common-BPZAsnhF.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const customerContainerSelector = "#customer-section-container";
const formViewChangeTriggersAttr = "data-form-view-change";
const formViewChangeTriggersSelector = `[${formViewChangeTriggersAttr}]`;
const customerRecoverSuccessSelector = ".customer__recover-success";
const customerLoginAlert = ".customer__login-alert";
const logoutButtonSelector = "#customer_logout_link";

const recoverFormSelector = ".customer__form-recover";
const recoverHash = "#recover";

const setActiveView$1 = (view) => {
  setDataAttr(customerContainerSelector, "active-form-view", view);
};

const isRecoverUrl = () => {
  const hash = window.location.hash;
  const recoverForm = qs(recoverFormSelector);
  return hash === recoverHash && recoverForm ? true : false;
};

const showRedirectWarning = () => {
  const alert = qs(customerLoginAlert);

  if (!alert) {
    return;
  }

  alert.style.display = "block";
};

const syncUTMTrackingParams = () => {
  const params = getStoredUTMParams();
  const el = document.getElementById("utm_params");
  if (el) {
    el.value = params;
  }
};

function registerFocusHandler() {
  const registerForm = document.querySelector("#create_customer");
  registerForm.removeEventListener("focusin", registerFocusHandler);
  trackSignupStarted();
}

const initBasicEventTracking = () => {
  const loginForm = document.querySelector("#customer_login");
  const registerForm = document.querySelector("#create_customer");
  //const passwordForm = document.querySelector(".customer__password-form form");

  if (window.location.pathname === "/account/login") {
    localStorage.removeItem("SHOPIFY_FORM_SUBMIT");
  }

  if (loginForm) {
    loginForm.addEventListener("submit", () => {
      localStorage.setItem("SHOPIFY_FORM_SUBMIT", "LOGIN_FORM");
    });
  }

  if (registerForm) {
    registerForm.addEventListener("submit", () => {
      localStorage.setItem("SHOPIFY_FORM_SUBMIT", "REGISTER_FORM");
    });
    registerForm.addEventListener("focusin", registerFocusHandler);
  }

  //if (passwordForm) {
  //  passwordForm.addEventListener("submit", () => {
  //    localStorage.setItem("SHOPIFY_FORM_SUBMIT", "PASSWORD_RESET_FORM");
  //  });
  //}
};

var initAccount = () => {
  click("#manage-subscription-btn", () => {
    showAccountManageWarning();
  });

  click(logoutButtonSelector, () => {
    destroyLocalTracking();
  });

  click(customerContainerSelector, (_el, e) => {
    if (e.target.matches(formViewChangeTriggersSelector)) {
      e.preventDefault();
      e.stopPropagation();

      const view = getAttr(e.target, formViewChangeTriggersAttr);
      setActiveView$1(view);
    }
  });

  if (window.__RECOVER_CUSTOMER_PASSWORD_SUCCESS === true) {
    addClass(customerRecoverSuccessSelector, "is-visible");
  }

  // If we're on the password recover form page, then make sure the form is shown
  // otherwise show login. Both will be hidden at page load.
  if (isRecoverUrl()) {
    setActiveView$1("recover");
  } else {
    setActiveView$1("login");
    showRedirectWarning();
    syncUTMTrackingParams();
  }

  initBasicEventTracking();
};

const showFormBtnSelector = ".address-show-new-btn";
const containerSelector = ".address";
const changeViewAttr = "data-form-view-change";
const changeViewTriggerSelector = `[${changeViewAttr}]`;
const itemActionAttr = "data-item-action";
const itemActionSelector = `[${itemActionAttr}]`;
const itemIdAttr = "data-item-id";
const itemConfirmAttr = "data-item-confirm-msg";
const editAddressAttr = "data-edit-address";
const editAddressSelector = `[${editAddressAttr}]`;

const setActiveView = (view) => {
  setDataAttr(containerSelector, "active-view", view);
};

const initAddressUI = () => {
  if (!Shopify || !Shopify.CountryProvinceSelector) {
    return;
  }

  if (qs("#AddressCountryNew")) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  runAll(".address-country-option", (el) => {
    const formId = getAttr(el, "data-form-id");
    const countrySelector = "AddressCountry_" + formId;
    const provinceSelector = "AddressProvince_" + formId;
    const containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });
};

const handleEditAction = (id) => {
  removeClass(editAddressSelector, "is-visible");
  setActiveView("edit");
  addClass(`[${editAddressAttr}="${id}"]`, "is-visible");
};

const handleDeleteAction = (formId) => {
  Shopify.postLink("/account/addresses/" + formId, {
    parameters: { _method: "delete" },
  });
};

const handleItemAction = (id, action) => {
  if (action === "edit") {
    handleEditAction(id);
    return;
  }

  if (action === "delete") {
    handleDeleteAction(id);
    return;
  }
  console.warn("Unsupported item action = %s", action);
};

var initAddress = () => {
  initAddressUI();

  click(containerSelector, (_el, e) => {
    if (e.target.matches(showFormBtnSelector)) {
      setActiveView("new");
      return;
    }

    if (e.target.matches(itemActionSelector)) {
      e.preventDefault();
      e.stopPropagation();
      const action = getAttr(e.target, itemActionAttr);
      const id = getAttr(e.target, itemIdAttr);
      const confirmMsg = getAttr(e.target, itemConfirmAttr);

      if (confirmMsg) {
        if (confirm(confirmMsg)) {
          handleItemAction(id, action);
        }
      } else {
        handleItemAction(id, action);
      }
      return;
    }

    if (e.target.matches(changeViewTriggerSelector)) {
      const view = getAttr(e.target, changeViewAttr);
      setActiveView(view);
    }
  });
};

onReady(() => {
  initAccount();
  initAddress();
});
